import { withNamespaces } from 'react-i18next';
import { Button } from 'reactstrap';

const MessagePagination = ({
    t,
    page,
    limit,
    total,
    totalPages,
    count = 0,
    onPageChange,
}) => {
    const start = count ? ((page - 1) * limit) + 1 : 0;
    const end = count ? ((page - 1) * limit) + count : 0;
    const displayTotal = total || end;

    if (!displayTotal && (!totalPages || totalPages <= 1)) {
        return null;
    }

    return (
        <div className="d-flex align-items-center justify-content-between mt-3 mailbox-pagination">
            <span className="text-muted">
                {t('Showing {{start}} - {{end}} of {{total}}', {
                    start,
                    end,
                    total: displayTotal,
                })}
            </span>
            <div>
                <Button
                    type="button"
                    color="primary"
                    className="me-2 mailbox-pagination__btn"
                    disabled={page <= 1}
                    onClick={() => onPageChange(page - 1)}
                >
                    <i className="mdi mdi-chevron-left font-size-18" />
                </Button>
                <Button
                    type="button"
                    color="primary"
                    className="mailbox-pagination__btn"
                    disabled={!totalPages || page >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                >
                    <i className="mdi mdi-chevron-right font-size-18" />
                </Button>
            </div>
        </div>
    );
};

export default withNamespaces()(MessagePagination);
